
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/environments",
      function () {
        return require("private-next-pages/environments/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/environments"])
      });
    }
  